import { ROUTE_MAP } from '../../../services/messaging-navigation';
import { service } from '@ember/service';
import { setOwner } from '@ember/application';

export default class WebsocketActivityHandlersActiveConversation {
  @service messaging;
  @service messagingNavigation;

  constructor(owner) {
    setOwner(this, owner);
  }

  get onConversationRoute() {
    return this.messagingNavigation.isCurrentRoute(ROUTE_MAP.conversation);
  }

  handleActivity(_response) {
    if (!this.onConversationRoute) {
      return;
    }

    const handler = this.messagingNavigation.currentRoute.handler;
    const conversation = handler.conversation;

    if (!conversation) {
      return;
    }

    handler.fetchAndValidateUsers.perform(conversation);
  }
}
